// Progressive enhancement preserves Shopify article HTML and confines wide tables.
if (!customElements.get('hc-article-content')) {
  customElements.define('hc-article-content', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('table').forEach(table => {
        if (table.parentElement.classList.contains('hc-table-scroll')) return;
        const region = document.createElement('div');
        region.className = 'hc-table-scroll';
        region.tabIndex = 0;
        region.setAttribute('role', 'region');
        region.setAttribute('aria-label', table.caption?.textContent || 'Article table');
        table.before(region);
        region.append(table);
      });
    }
  });
}
